export interface Env {
  ApiUrl: string
  OpenAccountUrl: string
  ResUrl: string
  CookieDomain: string
  ArrowedBackUrl: string
}

const env = {
  ApiUrl: process.env.VUE_APP_API_URL as string,
  OpenAccountUrl: process.env.VUE_APP_OPEN_ACCOUNT_URL as string,
  ResUrl: process.env.VUE_APP_RES_URL as string,
  CookieDomain: process.env.VUE_APP_COOKIE_DOMAIN as string,
  ArrowedBackUrl: process.env.VUE_APP_ARROWED_BACK_URL as string,
} as Env

export default env
